import React from "react";
import { Plus } from "lucide-react";

const SECTION_DEFS = [
  { key: "custom", label: "Custom section" },
  { key: "websites", label: "Website or social media" },
  { key: "hobbies", label: "Hobbies" },
  { key: "extracurricular", label: "Extra-curricular activities" },
];

/** "Add sections" pill bar (matches a BetterCV-style resume builder). "Custom section" always
 * stays visible since a resume can have multiple custom blocks (Publications, Awards, etc.);
 * the other 3 pills disappear once that section has been revealed at least once. */
export default function AddSectionsBar({ draft, setDraft, revealed, onReveal }) {
  const addCustomSection = () => setDraft({ ...draft, custom_sections: [...draft.custom_sections, { id: `${Date.now()}`, title: "", items: [] }] });

  const handleClick = (key) => {
    if (key === "custom") {
      addCustomSection();
      return;
    }
    onReveal(key);
  };

  const visibleDefs = SECTION_DEFS.filter((d) => d.key === "custom" || !revealed.has(d.key));
  if (visibleDefs.length === 0) return null;

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-add-sections-bar">
      <p className="text-sm font-semibold text-white mb-3">Add sections</p>
      <div className="flex flex-wrap gap-2">
        {visibleDefs.map((d) => (
          <button
            key={d.key} onClick={() => handleClick(d.key)} data-testid={`resume-add-section-${d.key}`}
            className="flex items-center gap-1.5 text-xs font-semibold text-slate-200 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-3.5 py-1.5 transition-colors"
          >
            <Plus className="w-3 h-3" /> {d.label}
          </button>
        ))}
      </div>
    </div>
  );
}
